__turbopack_context__.v({
  "arrow": "style-module-scss-module__7qIvOW__arrow",
  "card-wrapper": "style-module-scss-module__7qIvOW__card-wrapper",
  "component": "style-module-scss-module__7qIvOW__component",
  "full-screen": "style-module-scss-module__7qIvOW__full-screen",
  "full-screen-inner": "style-module-scss-module__7qIvOW__full-screen-inner",
  "full-screen-outer": "style-module-scss-module__7qIvOW__full-screen-outer",
  "hover": "style-module-scss-module__7qIvOW__hover",
  "scroller-inner": "style-module-scss-module__7qIvOW__scroller-inner",
  "scroller-outer": "style-module-scss-module__7qIvOW__scroller-outer",
});
